import { ref } from 'vue'

class NotificationService {

  messages = ref<NotificationMessage[]>([])

  info(text: string, options: NotificationOptions = {}): void {
    return this.publish(text, {...options, type: 'info'})
  }

  success(text: string, options: NotificationOptions = {}): void {
    return this.publish(text, {...options, type: 'success'})
  }

  error(text: string, options: NotificationOptions = {}): void {
    return this.publish(text, {...options, type: 'error'})
  }

  warn(text: string, options: NotificationOptions = {}): void {
    return this.publish(text, {...options, type: 'warn'})
  }

  /**
   * The convenience methods above - info(), success(), and error() - are more
   * concise. But calling this method directly might be appropriate if you need
   * to specify the message type dynamically.
   * @todo probably need some way to clean these out once they've been dismissed, so they don't stay in the ref forever
   */
  publish(text: string, options: NotificationOptions): void {

    const defaultOptions = {
      type: 'info',
      dismissible: true,
      timeout: 5000,
      show: true,
    }

    const effectiveOptions = Object.assign(defaultOptions, options)

    const typeColors = {
      info: 'info',
      success: 'green',
      error: 'error',
      warn: 'orange',
    }

    if (!(effectiveOptions.type in typeColors)) {
      console.warn(effectiveOptions.type + ' is not a valid message type')
      effectiveOptions.type = 'info'
    }

    this.messages.value.push({
      text: text,
      color: typeColors[effectiveOptions.type],
      dismissible: effectiveOptions.dismissible,
      timeout: effectiveOptions.timeout,
      show: true,
    })

  }

}

export default new NotificationService()

export type NotificationOptions = {
  type?: NotificationType
  dismissible?: boolean
  timeout?: number
  show?: boolean
}

type NotificationMessage = {
  text: string
  color: string
  dismissible: boolean
  timeout: number
  show: boolean
}

type NotificationType = 'info' | 'success' | 'error' | 'warn'
